import { db } from "../firebase.js";

export const updateSubjects = (newsubs) => {
  const docRef = db.collection("allPapers").doc("all-papers");
  docRef
    .get()
    .then((doc) => doc.data().data)
    .then((data) => {
      if (data) newsubs = data.concat(newsubs);
      newsubs.sort();
    })
    .then(() => {
      // console.log(newsubs);

      docRef
        .set({ data: newsubs })
        .then(() => {
          // console.log(newsubs);
          console.log("Document successfully written!");
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    })
    .catch((error) => console.error("Error fetching document: ", error));
};

export const fetchSubjects = async () => {
  // let topics = [];
  const docRef = db.collection("allPapers").doc("all-papers");
  return docRef
    .get()
    .then((doc) => doc.exists && doc.data().data )
    // .then((data) => {
    //   console.log(data);
    //   return data;
    // })
    .catch((error) => console.error("Error fetching document: ", error));
  
};

export const updateOccupiedTopics = async (email ,topics ) => {
  const docRef = db.collection("user-details").doc(email);
  docRef
    .get()
    .then((doc) => doc.data().occupiedPapers)
    .then((data) => {
      if (data) topics = data.concat(topics);
      // Remove Duplicates...
      topics = topics.filter(function (item, pos) {
        return topics.indexOf(item) === pos;
      });
    })
    .then(() => {
      // console.log(newsubs);
      docRef
        .update({ occupiedPapers: topics })
        .then(() => {
          // console.log(newsubs);
          console.log("Document successfully written!");
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    })
    .catch((error) => console.error("Error fetching document: ", error));
};
export const occupiedPapers = async (email) => {
  const docRef = db.collection("user-details").doc(email);
  // console.log(email);
  return docRef
    .get()
    .then((doc) => doc.exists && doc.data())
    .catch((error) => {
      console.log("Error getting document:", error);
    });
}
